import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import Home from './pages/Home';
import MergePDF from './pages/MergePDF';
import SplitPDF from './pages/SplitPDF';
import CompressPDF from './pages/CompressPDF';
import DeletePages from './pages/DeletePages';
import PDFToImage from './pages/PDFToImage';
import ImageToPDF from './pages/ImageToPDF';
import TranslateDoc from './pages/TranslateDoc';
import Convert from './pages/Convert';
import Login from './pages/Login';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import './styles/index.css';

const App: React.FC = () => {
    return (
        <AuthProvider>
            <Router>
                <MainLayout>
                    <Routes>
                        {/* Public route */}
                        <Route path="/login" element={<Login />} />

                        {/* Protected routes */}
                        <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                        <Route path="/convert" element={<ProtectedRoute><Convert /></ProtectedRoute>} />
                        <Route path="/merge" element={<ProtectedRoute><MergePDF /></ProtectedRoute>} />
                        <Route path="/split" element={<ProtectedRoute><SplitPDF /></ProtectedRoute>} />
                        <Route path="/compress" element={<ProtectedRoute><CompressPDF /></ProtectedRoute>} />
                        <Route path="/delete" element={<ProtectedRoute><DeletePages /></ProtectedRoute>} />
                        <Route path="/pdf-to-image" element={<ProtectedRoute><PDFToImage /></ProtectedRoute>} />
                        <Route path="/image-to-pdf" element={<ProtectedRoute><ImageToPDF /></ProtectedRoute>} />
                        <Route path="/translate" element={<ProtectedRoute><TranslateDoc /></ProtectedRoute>} />
                    </Routes>
                </MainLayout>
            </Router>
        </AuthProvider>
    );
};

export default App;
